const QR_RX = /;|,/;
export function parseQR(code) {
  if (isQR(code)) {
    return `${code.split(QR_RX)[1]}`;
  }
  return code;
}
export function isQR(code) {
  const parts = code.split(QR_RX);
  return parts.length === 6;
}